import { graphql } from "lib/generated/app-service-gql";
import {
  BidOrchestratorStatusSubscription,
  BidOrchestratorStatusSubscriptionVariables,
} from "lib/generated/app-service-gql/graphql";
import { useSubscription, UseSubscriptionOptions } from "../../useGraphQlClient";

// adding this so it generates the types
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _bidOrchestratorStatus = graphql(`
  subscription BidOrchestratorStatus($bidId: String!) {
    bidOrchestratorStatus(bidId: $bidId) {
      bidId
      status
      runId
      fileIds
      title
      qualificationReportId
      requirementSummaryReportId
      section
      bidQuestionId
      content
      isComplete
      errorMessage
      sources {
        documentId
        fileName
        type
        id
        title
        url
        chunkNumber
        documentType
        filePath
        isDeleted
        citationId
        locations {
          pageNumber
          bbox {
            x
            y
            width
            height
          }
        }
      }
      streamingQuestions {
        bidQuestionId
        title
        order
        groupName
      }
      qualificationReport {
        result {
          groupName
          questions {
            answerId
            autoQualify
            title
            order
            answer {
              answer
            }
            sources {
              documentId
              fileName
              type
              id
              title
              url
              chunkNumber
              documentType
              filePath
              isDeleted
              citationId
              locations {
                pageNumber
                bbox {
                  x
                  y
                  width
                  height
                }
              }
            }
          }
        }
      }
      requirementSummaryReport {
        result {
          groupName
          questions {
            answerId
            autoQualify
            title
            order
            answer {
              answer
            }
            sources {
              documentId
              fileName
              type
              id
              title
              url
              chunkNumber
              documentType
              filePath
              isDeleted
              citationId
              locations {
                pageNumber
                bbox {
                  x
                  y
                  width
                  height
                }
              }
            }
          }
        }
      }
    }
  }
`);

export type BidOrchestratorSubscriptionStatusEvent =
  BidOrchestratorStatusSubscription["bidOrchestratorStatus"];

export function useBidOrchestratorStatusSubscription(
  bidId: string,
  options: UseSubscriptionOptions<BidOrchestratorStatusSubscription>,
) {
  return useSubscription<
    BidOrchestratorStatusSubscription,
    BidOrchestratorStatusSubscriptionVariables
  >(
    `
  subscription BidOrchestratorStatus($bidId: String!) {
    bidOrchestratorStatus(bidId: $bidId) {
      bidId
      status
      runId
      fileIds
      title
      qualificationReportId
      requirementSummaryReportId
      section
      bidQuestionId
      content
      isComplete
      errorMessage
      sources {
        documentId
        fileName
        type
        id
        title
        url
        chunkNumber
        documentType
        filePath
        isDeleted
        citationId
        locations {
          pageNumber
          bbox {
            x
            y
            width
            height
          }
        }
      }
      streamingQuestions {
        bidQuestionId
        title
        order
        groupName
      }
      qualificationReport {
        result {
          groupName
          questions {
            answerId
            autoQualify
            title
            order
            answer {
              answer
            }
            sources {
              documentId
              fileName
              type
              id
              title
              url
              chunkNumber
              documentType
              filePath
              isDeleted
              citationId
              locations {
                pageNumber
                bbox {
                  x
                  y
                  width
                  height
                }
              }
            }
          }
        }
      }
      requirementSummaryReport {
        result {
          groupName
          questions {
            answerId
            autoQualify
            title
            order
            answer {
              answer
            }
            sources {
              documentId
              fileName
              type
              id
              title
              url
              chunkNumber
              documentType
              filePath
              isDeleted
              citationId
              locations {
                pageNumber
                bbox {
                  x
                  y
                  width
                  height
                }
              }
            }
          }
        }
      }
    }
  }
`,
    { bidId: bidId },
    { ...options, enabled: (options.enabled ?? true) && Boolean(bidId) },
  );
}
